import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLeaderboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLeaderboard"><Path d="M8.5 6V18H15.5V6H8.5Z" fill="currentColor"/><Path d="M0.5 8.5V18H7V8.5H0.5Z" fill="currentColor"/><Path d="M17 10V18H23.5V10H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLeaderboard;
